import React, { useEffect, useState, useMemo } from 'react'
import { useSnackbar } from 'notistack';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import DeptEmpList from '../../components/deptmng/DeptEmpList'
import * as departApi from '../../lib/api/department';
import _ from 'lodash';

const DeptEmpListContainer = ({ depart }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;
    if (depart) {
      onLoadData(depart);
    }
    return () => { isMounted = false };
  }, [depart])

  const onLoadData = async (depart) => {
    setLoading(true);
    try {
      const res = await departApi.getEmpsByDepart(depart.dptUuid);

      if (res.data.list) {
        const employees = res.data.list.map((employee) => ({
          id: employee.usrUuid,
          usrUuid: employee.usrUuid,
          usrNo: employee.usrNo,
          usrNm: employee.usrNm,
          emlAddr: employee.emlAddr,
          telNo: employee.telNo,
          infoDesc: employee.infoDesc,
          postAddrTxt: employee.postAddrTxt,
          postAddrNm: employee.postAddrNm,
          entryDt: employee.entryDt,
          dptUuid: employee.dptUuid,
          dptNm: employee.dptNm,
          gradeUuid: employee.gradeUuid,
          gradeNm: employee.gradeNm,
          profileImg: employee.profileImg,
          gender: employee.gender,
          useYn: employee.useYn === 'Y' ? true : false,
          crtNm: employee.crtNm,
          crtDt: employee.crtDt,
          cngNm: employee.cngNm,
          cngDt: employee.cngDt,
        }))

        // console.log(employees,'employees');
        setRows(employees);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setLoading(false);
  }


  const apiRef = useGridApiRef();

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'usrUuid',
        headerName: '사번',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'dptNm',
        headerName: '부서명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'usrNm',
        headerName: '이름',
        minWidth: 100,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'gradeNm',
        headerName: '직급',
        minWidth: 100,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'telNo',
        headerName: '연락처',
        minWidth: 120,
        flex: 0.6,
        type: 'string',
        editable: false,
      },
      {
        field: 'emlAddr',
        headerName: '이메일',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },

      {
        field: 'gender',
        headerName: '성별',
        minWidth: 80,
        flex: 0.6,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => (
          (params.value === 'M') ? '남성' : '여성'
        )
      }

    ],
    [],
  );

  return (
    <div>

      <DeptEmpList apiRef={apiRef} columns={columns} rows={rows} loading={loading} />
    </div>

  )
}

export default DeptEmpListContainer